var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('div',{staticClass:"function"},[_c('div',{staticClass:"title"},[_vm._v("更多功能")]),_vm._v(" "),_c('div',{staticClass:"write"},[_vm._v("\n          更多实用功能，等待您的体验\n      ")]),_vm._v(" "),_c('div',{staticClass:"port"},[_c('Four')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32f30d78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/software/function.vue
// module id = null
// module chunks = 